import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'src/app/services/auth.service';
import { FormControl, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { ApiService } from 'src/app/services/api.service';
import { UserService } from 'src/app/services/user.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-activity-log',
  templateUrl: './activity-log.component.html',
  styleUrls: ['./activity-log.component.scss'],
  
})
export class ActivityLogComponent implements OnInit {

  currentUser: any = undefined;

  organisations: Array<{ id: string; organisationName: string }> = [];
  filteredUsers: Array<any> = [];

  // Track selected values for edit detection
  selectedUserId: string = '';
  selectedUserName: string = '';
  selectedOrgId: string = '';

  get displayedColumns(): string[] {
    const cols = ['name', 'email', 'date', 'latestAction'];
    if (this.isMainSuperUser) {
      cols.splice(2, 0, 'organisationName');
    }
    return cols;
  }

  timezone: string = 'UTC';

  // helper: true when Local Time display is active
  get isConvertTimeOn(): boolean {
    return this.timezone === 'Local Time';
  }

  dataSource = new MatTableDataSource<any>([]);

  todayDate: Date = new Date();

  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });

  orgSearchControl:any = new FormControl('');
  userSearchControl:any = new FormControl('');

  stDate: Date | null = null;
  endDate: Date | null = null;

  organisationId: string = '';
  userId: string = '';

  pageIndex: number = 0;
  totalCount: number = 0;

  filteredData: any[] = [];
  tableDataLength: number = 0;

  isLoading: boolean = false;
  isMainSuperUser: boolean = false;

  @ViewChild('tableScrollContainer') tableScrollContainer: ElementRef;

  actionLabelMap: { [key: string]: string } = {

    // Sensor-based Task lifecycle
    sensor_task_created: 'Sensor-based Task Created',
    sensor_task_ordered: 'Sensor-based Task Ordered',
    sensor_task_cancelled: 'Sensor-based Task Cancelled',
    sensor_task_cancel_requested: 'Sensor-based Task Cancel Requested',
    sensor_task_viewed: 'Sensor-based Task Viewed',
    sensor_task_downloaded: 'Sensor-based Task Downloaded',
    sensor_task_returned: 'Sensor-based Task Returned',
    sensor_task_return_requested: 'Sensor-based Task Return Requested',
    sensor_task_return_rejected: 'Sensor-based Task Return Rejected',

    // Sensor visualization lifecycle
    sensor_task_scene_viewed: 'Sensor-based Task Scene Viewed',
    sensor_task_scene_downloaded: 'Sensor-based Task Scene Downloaded',
    sensor_task_sensor_viewed: 'Sensor-based Task Sensor Viewed',
    sensor_task_sensor_downloaded: 'Sensor-based Task Sensor Downloaded',
    sensor_task_feed_viewed: 'Sensor-based Task Feed Viewed',
    sensor_task_feed_downloaded: 'Sensor-based Task Feed Downloaded',

    sensor_task_indices_viewed: 'Sensor-based Task Indices Viewed',
    sensor_task_indices_downloaded: 'Sensor-based Task Indices Downloaded',

    sensor_task_super_resolution_viewed: 'Sensor-based Task Super Resolution Viewed',
    sensor_task_super_resolution_downloaded: 'Sensor-based Task Super Resolution Downloaded',

    // Sensor reports lifecycle
    sensor_task_reports_created: 'Sensor-based Task Report Created',
    sensor_task_reports_viewed: 'Sensor-based Task Report Viewed',
    sensor_task_reports_deleted: 'Sensor Task Report Deleted',
    sensor_task_reports_downloaded: 'Sensor Task Report Downloaded',

    // Sensor product return lifecycle
    sensor_task_vadp_return_requested: 'Sensor-based Task VADP Return Requested',
    sensor_task_vadp_returned: 'Sensor-based Task VADP Returned',
    sensor_task_vadp_return_rejected: 'Sensor-based Task VADP Return Rejected',

    sensor_task_super_resolution_return_requested: 'Sensor-based Task Super Resolution Return Requested',
    sensor_task_super_resolution_returned: 'Sensor-based Task Super Resolution Returned',
    sensor_task_super_resolution_return_rejected: 'Sensor-based Task Super Resolution Return Rejected',

    sensor_task_indices_return_requested: 'Sensor-based Task Indices Return Requested',
    sensor_task_indices_returned: 'Sensor-based Task Indices Returned',
    sensor_task_indices_return_rejected: 'Sensor-based Task Indices Return Rejected',

    sensor_task_feed_return_requested: 'Sensor-based Task Feed Return Requested',
    sensor_task_feed_returned: 'Sensor-based Task Feed Returned',
    sensor_task_feed_return_rejected: 'Sensor-based Task Feed Return Rejected',

    sensor_task_scene_return_requested: 'Sensor-based Task Scene Return Requested',
    sensor_task_scene_returned: 'Sensor-based Task Scene Returned',
    sensor_task_scene_return_rejected: 'Sensor-based Task Scene Return Rejected',

    sensor_task_tile_return_requested: 'Sensor-based Task Tile Return Requested',
    sensor_task_tile_returned: 'Sensor-based Task Tile Returned',
    sensor_task_tile_return_rejected: 'Sensor-based Task Tile Return Rejected',

    sensor_task_refreshes_fetches_return_requested: 'Sensor-based Task Refreshes Fetches Return Requested',
    sensor_task_refreshes_fetches_returned: 'Sensor-based Task Refreshes Fetches Returned',
    sensor_task_refreshes_fetches_return_rejected: 'Sensor-based Task Refreshes Fetches Return Rejected',

    sensor_task_azista_return_requested: 'Sensor-based Task Azista Return Requested',
    sensor_task_azista_returned: 'Sensor-based Task Azista Returned',
    sensor_task_azista_return_rejected: 'Sensor-based Task Azista Return Rejected',

    sensor_task_sensor_return_requested: 'Sensor-based Task Sensor Return Requested',
    sensor_task_sensor_returned: 'Sensor-based Task Sensor Returned',
    sensor_task_sensor_return_rejected: 'Sensor-based Task Sensor Return Rejected',

    // Collection lifecycle
    collection_created: 'Collection-based Task Created',
    collection_ordered: 'Collection-based Task Ordered',
    collection_cancelled: 'Collection-based Task Cancelled',
    collection_cancel_requested: 'Collection-based Task Cancel Requested',
    collection_viewed: 'Collection-based Task Viewed',
    collection_downloaded: 'Collection-based Task Downloaded',
    collection_returned: 'Collection-based Task Returned',
    collection_return_requested: 'Collection-based Task Return Requested',
    collection_return_rejected: 'Collection-based Task Return Rejected',

    // Collection visualization lifecycle
    collection_scene_viewed: 'Collection-based Task Scene Viewed',
    collection_scene_downloaded: 'Collection-based Task Scene Downloaded',
    collection_sensor_viewed: 'Collection-based Task Sensor Viewed',
    collection_sensor_downloaded: 'Collection-based Task Sensor Downloaded',
    collection_feed_viewed: 'Collection-based Task Feed Viewed',
    collection_feed_downloaded: 'Collection-based Task Feed Downloaded',

    collection_indices_viewed: 'Collection-based Task Indices Viewed',
    collection_indices_downloaded: 'Collection-based Task Indices Downloaded',

    collection_super_resolution_viewed: 'Collection-based Task Super Resolution Viewed',
    collection_super_resolution_downloaded: 'Collection-based Task Super Resolution Downloaded',

    // Collection reports lifecycle
    collection_report_created: 'Collection-based Report Created',
    collection_report_viewed: 'Collection-based Report Viewed',
    collection_report_deleted: 'Collection-based Report Deleted',
    collection_report_downloaded: 'Collection-based Report Downloaded',

    collection_task_reports_created: 'Collection-based Task Report Created',
    collection_task_reports_viewed: 'Collection-based Task Report Viewed',
    collection_task_reports_deleted: 'Collection-based Task Report Deleted',
    collection_task_reports_downloaded: 'Collection-based Task Report Downloaded',

    // Collection return lifecycle
    collection_vadp_return_requested: 'Collection-based Task VADP Return Requested',
    collection_vadp_returned: 'Collection-based Task VADP Returned',
    collection_vadp_return_rejected: 'Collection-based Task VADP Return Rejected',

    collection_super_resolution_return_requested: 'Collection-based Task Super Resolution Return Requested',
    collection_super_resolution_returned: 'Collection-based Task Super Resolution Returned',
    collection_super_resolution_return_rejected: 'Collection-based Task Super Resolution Return Rejected',

    collection_indices_return_requested: 'Collection-based Task Indices Return Requested',
    collection_indices_returned: 'Collection-based Task Indices Returned',
    collection_indices_return_rejected: 'Collection-based Task Indices Return Rejected',

    collection_feed_return_requested: 'Collection-based Task Feed Return Requested',
    collection_feed_returned: 'Collection-based Task Feed Return Returned',
    collection_feed_return_rejected: 'Collection-based Task Feed Return Rejected',

    collection_scene_return_requested: 'Collection-based Task Scene Return Requested',
    collection_scene_returned: 'Collection-based Task Scene Return Returned',
    collection_scene_return_rejected: 'Collection-based Task Scene Return Rejected',

    collection_sensor_return_requested: 'Collection-based Task Sensor Return Requested',
    collection_sensor_returned: 'Collection-based Task Sensor Return Returned',
    collection_sensor_return_rejected: 'Collection-based Task Sensor Return Rejected',

    // Feed lifecycle
    feed_added: 'Feed Added',
    feed_ordered: 'Feed Ordered',
    feed_cancelled: 'Feed Cancelled',
    feed_cancel_requested: 'Feed Cancel Requested',
    feed_viewed: 'Feed Viewed',
    feed_downloaded: 'Feed Downloaded',
    feed_returned: 'Feed Returned',
    feed_return_requested: 'Feed Return Requested',
    feed_return_rejected: 'Feed Return Rejected',

    feed_scene_viewed: 'Feed Scene Viewed',
    feed_sensor_viewed: 'Feed Sensor Viewed',
    feed_is_viewed: 'Feed Viewed',

    // Question-based Task lifecycle
    qs_task_created: 'Question-based Task Created',
    qs_task_ordered: 'Question-based Task Ordered',
    qs_task_cancelled: 'Question-based Task Cancelled',
    qs_task_cancel_requested: 'Question-based Task Cancel Requested',
    qs_task_viewed: 'Question-based Task Viewed',
    qs_task_downloaded: 'Question-based Task Downloaded',
    qs_task_returned: 'Question-based Task Returned',
    qs_task_return_requested: 'Question-based Task Return Requested',
    qs_task_return_rejected: 'Question-based Task Return Rejected',

    // QS visualization lifecycle
    qs_task_sensor_viewed: 'Question-based Task Sensor Viewed',

    // QS return lifecycle
    qs_task_vadp_return_requested: 'Question-based Task VADP Return Requested',
    qs_task_vadp_returned: 'Question-based Task VADP Returned',
    qs_task_vadp_return_rejected: 'Question-based Task VADP Return Rejected',

    qs_task_super_resolution_return_requested: 'Question-based Task Super Resolution Return Requested',
    qs_task_super_resolution_returned: 'Question-based Task Super Resolution Returned',
    qs_task_super_resolution_return_rejected: 'Question-based Task Super Resolution Return Rejected',

    qs_task_indices_return_requested: 'Question-based Task Indices Return Requested',
    qs_task_indices_returned: 'Question-based Task Indices Returned',
    qs_task_indices_return_rejected: 'Question-based Task Indices Return Rejected',

    qs_task_feed_return_requested: 'Question-based Task Feed Return Requested',
    qs_task_feed_returned: 'Question-based Task Feed Returned',
    qs_task_feed_return_rejected: 'Question-based Task Feed Return Rejected',

    qs_task_scene_return_requested: 'Question-based Task Scene Return Requested',
    qs_task_scene_returned: 'Question-based Task Scene Returned',
    qs_task_scene_return_rejected: 'Question-based Task Scene Return Rejected',

    qs_task_sensor_return_requested: 'Question-based Task Sensor Return Requested',
    qs_task_sensor_returned: 'Question-based Task Sensor Returned',
    qs_task_sensor_return_rejected: 'Question-based Task Sensor Return Rejected',

    // Budget lifecycle
    budget_saved: 'Budget Task Saved',
    budget_tasked: 'Budget Task Executed',

    // Indices lifecycle
    indices_added: 'Indices Added',
    indices_ordered: 'Indices Ordered',
    indices_cancelled: 'Indices Cancelled',
    indices_cancel_requested: 'Indices Cancel Requested',
    indices_viewed: 'Indices Viewed',
    indices_downloaded: 'Indices Downloaded',
    indices_returned: 'Indices Returned',
    indices_return_requested: 'Indices Return Requested',
    indices_return_rejected: 'Indices Return Rejected',

    // VADP lifecycle
    vadp_added: 'VADP Added',
    vadp_ordered: 'VADP Ordered',
    vadp_cancelled: 'VADP Cancelled',
    vadp_cancel_requested: 'VADP Cancel Requested',
    vadp_viewed: 'VADP Viewed',
    vadp_downloaded: 'VADP Downloaded',
    vadp_returned: 'VADP Returned',
    vadp_return_requested: 'VADP Return Requested',
    vadp_return_rejected: 'VADP Return Rejected',

    // Super Resolution lifecycle
    super_resolution_added: 'Super Resolution Added',
    super_resolution_ordered: 'Super Resolution Ordered',
    super_resolution_cancelled: 'Super Resolution Cancelled',
    super_resolution_cancel_requested: 'Super Resolution Cancel Requested',
    super_resolution_viewed: 'Super Resolution Viewed',
    super_resolution_downloaded: 'Super Resolution Downloaded',
    super_resolution_returned: 'Super Resolution Returned',
    super_resolution_return_requested: 'Super Resolution Return Requested',
    super_resolution_return_rejected: 'Super Resolution Return Rejected'
  };


  constructor(
    private authService: AuthService,
    private apiService: ApiService,
    private userService: UserService,
    private utilsService: UtilsService
  ) {}

  ngOnInit(): void {
    this.currentUser = this.authService.userValue;
    this.userService.personalInfo(this.currentUser?.id).subscribe(async (res: any) => {
      let userDetails = await res;
      this.isMainSuperUser = userDetails?.userType === 'Super user' && !userDetails?.isSubAccount && userDetails?.user_plan == 4 ? true : false;
    });
    this.getActivityLogs();
  }

  datewiseOrder(type: string, e: any) {

    if (type === 'start') this.stDate = e.value;
    if (type === 'end') this.endDate = e.value;

    if (this.stDate && this.endDate) {

      this.pageIndex = 0;
      this.filteredData = [];
      this.totalCount = 0;
      this.tableDataLength = 0;

      this.getActivityLogs();
    }
  }

  private buildActivityLogRequest(pageIndex: number) {

    if (this.stDate && this.endDate) {

      const startDate = moment(this.stDate)
        .utcOffset(0, true)
        .format();

      const endDate = moment(this.endDate)
        .utcOffset(0, true)
        .add(86399, 'seconds')
        .format();

      return {
        organisationId: this.organisationId,
        userId: this.userId,
        startDate,
        endDate,
        pageIndex
      };
    }

    return {
      organisationId: this.organisationId,
      userId: this.userId,
      startDate: '',
      endDate: '',
      pageIndex
    };
  }

  getActionLabel(action: string): string {
    return this.actionLabelMap[action] || action;
  }

  getActivityLogs() {

    if (this.isLoading) return;

    this.isLoading = true;

    const params = this.buildActivityLogRequest(this.pageIndex);
    const userId = this.currentUser?.id || '';

    this.apiService.getActivityLogs(userId, params).subscribe(
      (result: any) => {

        this.totalCount = result?.total || 0;

        const rows = (result?.data || []).map((x: any) => {

          x.name = x.fullName || '';
          x.date = x.dateTime || '';
          x.organisationName = x.organisationName || '';
          const actionKey = x.latestAction || x.action || '';
          x.latestAction = this.getActionLabel(actionKey);
          x.type = x?.obfuscated_name || x.metadata?.feedDetails?.[0]?.feedName || x.metadata?.product_type || x.metadata?.sensor_name || '';
          
          const actionMeta = this.getActionMeta(actionKey);
          x.actionIcon = actionMeta.icon;
          x.actionClass = actionMeta.className;
          return x;
        });

        // apply timezone handling to newly fetched rows so lazy-loaded data
        // matches the current display mode (UTC or Local Time)
        this.applyTimezoneToRows(rows);

        this.filteredData = this.filteredData.concat(rows);
        this.tableDataLength = this.filteredData.length;

        this.dataSource = new MatTableDataSource(this.filteredData);

        this.isLoading = false;

        setTimeout(() => {

          const target = this.tableScrollContainer?.nativeElement as HTMLElement;
          if (!target) return;

          if (
            this.filteredData.length < this.totalCount &&
            target.scrollHeight <= target.clientHeight
          ) {
            this.pageIndex++;
            this.getActivityLogs();
          }

        }, 0);

      },
      () => {

        this.isLoading = false;
        this.totalCount = 0;
        this.filteredData = [];
        this.tableDataLength = 0;
        this.dataSource = new MatTableDataSource<any>([]);

      }
    );
  }

  // Reuse existing conversion logic for rows appended via lazy load.
  private applyTimezoneToRows(rows: any[]) {
    if (!rows || !rows.length) return;

    if (!this.isConvertTimeOn) {
      // ensure row.date is Date or ISO string for DatePipe when showing UTC
      for (const row of rows) {
        if (!(row.date instanceof Date)) {
          const original = row.dateTime || row.date;
          if (typeof original === 'string') {
            const parsed = new Date(original);
            if (!isNaN(parsed.getTime())) {
              row.date = parsed;
            }
          }
        }
      }
      return;
    }

    // conversion active: use convertDateAndTimes to set _displayDate
    for (const row of rows) {
      try {
        const converted = this.convertDateAndTimes(row);
        row._displayDate = converted?.dateTime || '';
      } catch (e) {
        row._displayDate = row.dateTime || row.date || '';
      }
      // also ensure row.date is a Date for DatePipe fallback
      if (!(row.date instanceof Date)) {
        const original = row.dateTime || row.date;
        if (typeof original === 'string') {
          const parsed = new Date(original);
          if (!isNaN(parsed.getTime())) {
            row.date = parsed;
          }
        }
      }
    }
  }

  resetTable() {
    this.pageIndex = 0;
    this.filteredData = [];
    this.totalCount = 0;
    this.tableDataLength = 0;
  }

  loadMoreData() {

    if (this.isLoading) return;

    if (this.filteredData.length < this.totalCount) {
      this.pageIndex++;
      this.getActivityLogs();
    }
  }

  onUserSearchInput(event: any) {

    const value = typeof event === 'string' ? event : event?.target?.value ?? '';

    const search = value.trim();

    if (search.length === 0) {
      this.userId = '';
      this.selectedUserId = '';
      this.selectedUserName = '';
      this.filteredUsers = [];

      this.resetTable();
      this.getActivityLogs();
      return;
    }

    // Ignore until 3 characters
    if (search.length < 3) {
      this.filteredUsers = [];
      return;
    }

    // If user edits after selection → clear filter
    if (this.selectedUserId && search !== this.selectedUserName) {
      this.userId = '';
      this.selectedUserId = '';
    }

    const currentUserId = this.currentUser?.id || '';

    this.apiService
      .getActivityUsers(currentUserId, search)
      .subscribe((res: any) => {
        this.filteredUsers = res?.data || [];
      });
  }

  // Called when user selects an option from dropdown
  onUserSelect(user: any) {

    if (user && user.userId) {

      this.userId = user.userId;
      this.selectedUserId = user.userId;
      this.selectedUserName = user.fullName;

      this.userSearchControl.setValue(user, { emitEvent: false });

      this.resetTable();
      this.getActivityLogs();
    }
  }

  onOrgSearchInput(event: any) {

    const value = typeof event === 'string' ? event : event?.target?.value ?? '';

    const search = value.trim();

    if (search.length === 0) {
      this.organisationId = '';
      this.selectedOrgId = '';
      this.organisations = [];

      this.resetTable();
      this.getActivityLogs();
      return;
    }

    if (search.length < 3) {
      this.organisations = [];
      return;
    }

    
    const selectedName = typeof this.orgSearchControl.value === 'object' ? this.orgSearchControl.value.organisationName : '';

    if (this.selectedOrgId && search !== selectedName) {
      this.organisationId = '';
      this.selectedOrgId = '';
    }

    const currentUserId = this.currentUser?.id || '';

    this.apiService
      .getActivityOrganisations(currentUserId, search)
      .subscribe((res: any) => {
        this.organisations = res?.data || [];
      });
  }

  // Called when user selects an option from dropdown
  onOrgSelect(org: any) {
    if (org && org.id) {
      this.organisationId = org.id;
      this.selectedOrgId = org.id;
      this.orgSearchControl.setValue(org, { emitEvent: false });
      this.resetTable();
      this.getActivityLogs();
    }
  }

  // Display function for user (shows selected user name only, not the search text)
  displayUser = (user: any) => {
    if (!user || typeof user === 'string') return '';
    return `${user.fullName || ''} - ${user.email || ''}`;
  };

  // Display function for organisation (shows selected org name only, not the search text)
  displayOrg = (org: any) => {
    if (!org || typeof org === 'string') return '';
    return org.organisationName || '';
  };

  // Helper: get search input text value for hint display
  getUserSearchInputValue(): string {
    const val = this.userSearchControl.value;
    return (typeof val === 'string' ? val : '');
  }

  getOrgSearchInputValue(): string {
    const val = this.orgSearchControl.value;
    return (typeof val === 'string' ? val : '');
  }

  convertTime(event: MouseEvent) {
    event.stopPropagation();
    this.timezone = this.timezone === 'UTC' ? 'Local Time' : 'UTC';
    
    for (const row of this.filteredData) {
      const convertedDates = this.convertDateAndTimes(row);
      // store a pre-formatted display string for Local Time to avoid DatePipe errors
      row._displayDate = convertedDates.dateTime;
      // ensure `row.date` remains a Date or ISO string for use with DatePipe when timezone is UTC
      if (!(row.date instanceof Date)) {
        const original = row.dateTime || row.date;
        if (typeof original === 'string') {
          const parsed = new Date(original);
          if (!isNaN(parsed.getTime())) {
            row.date = parsed;
          }
        }
      }
    }

    this.dataSource = new MatTableDataSource(this.filteredData);
  }

  convertDateAndTimes({ dateTime }: any) {
    return {
      dateTime: this.formatDate(dateTime)
    };
  }

  private formatDate(dateTime: string) {
    if (!dateTime) return null;

    return this.timezone === 'Local Time'
      ? this.utilsService.convertUtcToLocal(dateTime, this.currentUser)
      : dateTime;
  }
  
  clearDateRange(event: Event) {
    event.stopPropagation();
    this.range.reset();
    this.stDate = null;
    this.endDate = null;
    this.pageIndex = 0;
    this.filteredData = [];
    this.totalCount = 0;
    this.tableDataLength = 0;
    this.getActivityLogs();
  }

  // Clear all filters and reload initial data
  clearFilter(): void {
    try {
      if (this.orgSearchControl) this.orgSearchControl.setValue('');
      if (this.userSearchControl) this.userSearchControl.setValue('');
      if (this.range) this.range.reset();
    } catch (e) { }

    this.selectedOrgId = '';
    this.selectedUserId = '';
    this.organisationId = '';
    this.userId = '';

    this.filteredUsers = [];

    // reset table and reload default data
    this.filteredData = [];
    this.dataSource = new MatTableDataSource(this.filteredData);
    this.pageIndex = 0;
    this.getActivityLogs();
  }

  // Legacy method for backwards compatibility (if called from template)
  filterUsers(value: any) {
    if (value && value.userId !== undefined) {
      this.onUserSelect(value);
    } else {
      this.onUserSearchInput(value);
    }
  }

  // Legacy method for backwards compatibility (if called from template)
  filterOrganisations(value: any) {
    if (value && value.id !== undefined) {
      this.onOrgSelect(value);
    } else {
      this.onOrgSearchInput(value);
    }
  }
  
  get hasActiveFilters(): boolean {
    return !!(this.userId || this.organisationId || this.stDate || this.endDate);
  }
  
  getActionMeta(action: string): {icon: string;className: string;} {

    const value = (action || '').toLowerCase();

    if (value.includes('created') || value.includes('added')) {
      return {
        icon: 'add_circle',
        className: 'success-action'
      };
    }

    if (value.includes('ordered')) {
      return {
        icon: 'shopping_cart',
        className: 'ordered-action'
      };
    }

    if (value.includes('cancel')) {
      return {
        icon: 'cancel',
        className: 'cancel-action'
      };
    }

    if (value.includes('download')) {
      return {
        icon: 'download',
        className: 'download-action'
      };
    }

    if (value.includes('return')) {
      return {
        icon: 'keyboard_return',
        className: 'return-action'
      };
    }

    if (value.includes('view')) {
      return {
        icon: 'visibility',
        className: 'view-action'
      };
    }

    if (value.includes('delete')) {
      return {
        icon: 'delete',
        className: 'delete-action'
      };
    }

    if (value.includes('budget')) {

      if (value.includes('saved')) {
        return {
          icon: 'add_card',
          className: 'success-action'
        };
      }

      if (value.includes('tasked')) {
        return {
          icon: 'credit_score',
          className: 'ordered-action'
        };
      }
    }

    return {
      icon: 'info',
      className: 'default-action'
    };
  }
}
